"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMatricula = exports.yupMatricula = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupMatricula = yup.object({
    idCurso: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Curso'),
    idSerie: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Série'),
    idTurma: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Turma'),
    idAluno: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Aluno'),
    sequencia: yup.string().default(' ').label('Sequência'),
    grau: yup.string().default('').label('Nivel'),
    nrChamada: yup.string().default('').label('Numero Chamada'),
    frequencia: yup.number().default(0).label('Frequência'),
    data: (0, utils_1.sge2Date)().default(null).nullable().label('Data da Matrícula'),
    situacao: yup.string().default('1').label('Situação'),
    dataSaida: (0, utils_1.sge2Date)().default(null).nullable().label('Data Saida'),
    dataEntrada: (0, utils_1.sge2Date)().default(null).nullable().label('Data Entrada'),
    historico: yup.string().max(70, 'Máximo de 70 caracteres.').default('').label('Histórico de movimentações'),
    motivoSaida: yup.string().max(50, 'Máximo de 50 caracteres.').default('').label('Motivo da Saida'),
    tipo: yup.string().default('1').label('Tipo de curso'),
    confirmou: yup.boolean().required().default(false).label('Confirmou Matricula'),
    tipoAprovacao: yup.string().default('').label('Tipo Aprovação'),
    idCategoriaAluno: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .nullable()
        .label('Categoria Aluno'),
    idClasseAluno: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Classe Aluno'),
    idResponsavel: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Responsável'),
    idFiador: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Fiador'),
    idFpEntrada: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento Entrada'),
    entradaValorTotal: yup.number().min(0).default(0).label('Valor Total Entrada'),
    entradaValorDesconto: yup.number().min(0).default(0).label('Valor Desconto Entrada'),
    entradaValorParcela: yup.number().min(0).default(0).label('Valor Parcela Entrada'),
    entradaNumeroParcela: yup.number().min(0).default(0).label('Numero Parcela Entrada'),
    entradaDataVencimento: (0, utils_1.sge2Date)().default(null).nullable().label('Data Vencimento Entrada'),
    idFpAnuidade: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento Anuidade'),
    mensalValorAnuidade: yup.number().min(0).default(0).label('Valor Anuidade'),
    mensalValorCurso: yup.number().min(0).default(0).label('Valor Curso'),
    mensalValorDesconto: yup.number().min(0).default(0).label('Valor Desconto'),
    mensalValorParcela: yup.number().min(0).default(0).label('Valor Parcela'),
    mensalNumeroParcela: yup.number().min(0).default(0).label('Numero Parcela'),
    mensalDiaVencimento: yup.number().min(0).default(0).label('Dia Vencimento'),
    idFpMaterial: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento Material'),
    materialValorTotal: yup.number().min(0).default(0).label('Valor Total Material'),
    materialValorDesconto: yup.number().min(0).default(0).label('Valor Desconto Material'),
    materialValorParcela: yup.number().min(0).default(0).label('Valor Parcela Material'),
    materialNumeroParcela: yup.number().min(0).default(0).label('Numero Parcela Material'),
    materialDiaVencimento: yup.number().min(0).default(0).label('Dia Vencimento Material'),
});
exports.schemaMatricula = exports.yupMatricula.shape({});
